import useGeoInfo from "../hook/useGeoInfo"
import logoIke from '../img/logos/ike-asistencia.svg'
import logoComKare from '../img/logos/ike-komcare.svg'
import favIke from '../img/logos/ike-asistencia.ico'
import favComKare from '../img/logos/ike-komcare.ico'

export default function GetLogoSistema(props){
    const country = useGeoInfo()

    if(country?.ip?.country_code === "MX"){
        if(props === 'logo'){
            return logoIke
        }else if(props === 'favicon'){
            return favIke;
        }        
    }else if(country?.ip?.country_code === "CL"){
        if(props === 'logo'){
            return logoComKare
        }else if(props === 'favicon'){
            return favComKare;
        }
    }else if(country !== undefined){
        return ''
    }else{
        return undefined
    }
}